module.exports = "https://static.wmbcdn.com/uniweb/images/09e9087516731ba0e8614d2b7f65ce21.svg";